import React from 'react';
import { connect } from "react-redux";
import * as Constants from '../../Constants';
import { pageChangeWithNoStateChange, pageChange } from '../../action/view';
import { Link } from "react-router-dom";

function mapStateToProps(state) {
    return state;
}

const mapDispatchToProps = {
    pageChange,
    pageChangeWithNoStateChange
};
class AddSuccess extends React.Component {
    returnToBranches(e){
        this.props.pageChange(Constants.BRANCHES);
    }

    editBranchButton(e){
        this.props.pageChangeWithNoStateChange(Constants.BRANCHES);
    }

    render() {
        return (
            <div className="add-user-div normal-box float-left">
                <div className="add-user normal-margin center">
                    <img alt="Pistive Vote" src="/img/positive-vote.svg" className="postive-vote"></img>
                    <p>{this.props.branchView.message ? this.props.branchView.message: ""}</p>
                    <Link to="/branches" className="white-red-button" onClick={this.editBranchButton.bind(this)}>Edit Club</Link>
                    <br/>
                    <Link to="/branches" onClick={this.returnToBranches.bind(this)}><img src="/img/arrow-left-red.svg" alt="Arrow Left" className="arrow"></img>Return to branches</Link>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddSuccess);
